import { adminServerInstance, newRoutePlannerServerInstance } from "../axios/instances";
import { 
    GET_IS_ROUTES_SET, 
    GET_IS_ROUTES_SET_FAIL, 
    GET_IS_ROUTES_SET_SUCCESS, 
    GET_ROUTE_PLANNED_COUNT, 
    GET_ROUTE_PLANNED_COUNT_FAIL, 
    GET_ROUTE_PLANNED_COUNT_SUCCESS, 
    POST_ROUTE_PREVIEW, 
    POST_ROUTE_PREVIEW_FAIL, 
    POST_ROUTE_PREVIEW_SUCCESS, 
    POST_SAVE_ROUTE, 
    POST_SAVE_ROUTE_FAIL, 
    POST_SAVE_ROUTE_SUCCESS, 
    RESET_ROUTE_PREVIEW, 
    GET_ROUTE_PLANNERS, 
    GET_ROUTE_PLANNERS_SUCCESS, 
    GET_ROUTE_PLANNERS_FAIL, 
    HANDLE_CURRENT_DRIVER_ID, 
    HANDLE_CURRENT_ROUTE_TYPE,
    POST_ROUTE_PREVIEW_HOPPER, 
    POST_ROUTE_PREVIEW_HOPPER_FAIL, 
    POST_ROUTE_PREVIEW_HOPPER_SUCCESS, 
} from "./types";
import _ from 'lodash';

/** 
 * @param {Object} params - Combined object to send for server processing
 * @param {string} [params.planner_name] - Route planner name
 * @param {string} [params.batch_info] - Selected batches
 * @param {string} [params.service_number] - Current driver ID
 */
export function getRoutePlanners(params){
    return function(dispatch){
        dispatch({type: GET_ROUTE_PLANNERS})
        return adminServerInstance.get(`/map/getrouteplanners`, {
            params: params
        }).then(({data}) => {
            dispatch({
                type: GET_ROUTE_PLANNERS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_ROUTE_PLANNERS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

/** 
 * @param {number} [type] - 1->original, 2->VRP, 3->Hopper
 */
export function handleCurrentRouteType(type) {
    return function(dispatch){
    dispatch({type: HANDLE_CURRENT_ROUTE_TYPE})
    return (
        dispatch({
            type: HANDLE_CURRENT_ROUTE_TYPE,
            payload: type
        })
    )}
}

export function handleCurrentDriverId(driverId) {
    return function(dispatch){
    dispatch({type: HANDLE_CURRENT_DRIVER_ID})
    return (
        dispatch({
            type: HANDLE_CURRENT_DRIVER_ID,
            payload: driverId
        })
    )}
}

/** 
 * @param {Object} params - Combined object to send for server processing
 * @param {string} [params.orders] - {order_id, pack_id}
 * @param {string} [params.start] - Start lng and lat
 * @param {string} [params.end] - End lng and lat
 * @param {string} [params.warehouse] - Warehouse ID
 */
export function getRoutePreviewVRP(params){
    return function(dispatch){
        dispatch({type: POST_ROUTE_PREVIEW})
        return newRoutePlannerServerInstance.post(`/routeplan/`, params, { timeout: 0 }
            ).then(({data}) => {
                dispatch({
                    type: POST_ROUTE_PREVIEW_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: POST_ROUTE_PREVIEW_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

/** 
 * @param {Object} params - Combined object to send for server processing
 * @param {string} [params.orders] - {order_id, pack_id}
 * @param {string} [params.start] - Start lng and lat
 * @param {string} [params.end] - End lng and lat
 * @param {string} [params.warehouse] - Warehouse ID
 */
export function getRoutePreviewHopper(params){
    return function(dispatch){
        dispatch({type: POST_ROUTE_PREVIEW_HOPPER})
        return adminServerInstance.post(`/map/routeplanhopper`, params, { timeout: 0 })
        .then(({data}) => {
                data.data.routes = data.data.routes.map((order, index) => {
                    return {
                        pack_id: index,
                        order_id: order.id,
                        distance: order.distance_diff,
                        lat: order.address.lat,
                        lng: order.address.lon
                    }
                }).slice(1, -1);
                dispatch({
                    type: POST_ROUTE_PREVIEW_HOPPER_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: POST_ROUTE_PREVIEW_HOPPER_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

/** 
 * @param {Object} params - Combined object to send for server processing
 * @param {string} [params.orders] - {order_id, pack_id}
 * @param {string} [params.start] - Start lng and lat
 * @param {string} [params.end] - End lng and lat
 * @param {string} [params.warehouse] - Warehouse ID
 */
export function getRoutePreview(params){
    return function(dispatch){
        dispatch({type: POST_ROUTE_PREVIEW})
        return adminServerInstance.post(`/map/newgooglepath`, params)
        .then(({data}) => {
                dispatch({
                    type: POST_ROUTE_PREVIEW_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: POST_ROUTE_PREVIEW_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            })
    }
}

export function resetRoutePreview(){
    return function(dispatch){
        dispatch({type: RESET_ROUTE_PREVIEW})
    }
}

/**
 * @param {Object} params
 * @param {Array} params.orders
 * @param {string} params.driver_notes
 * @param {string} params.batch_info
 * @param {string} params.service_number
 * @param {Number} params.distance
 * @param {Number} params.duration
 * @param {string} params.planner_type
*/
export function saveRoutes(params){
    return function(dispatch){
        dispatch({type: POST_SAVE_ROUTE})
        return adminServerInstance.post('/map/savepath', params)
        .then(({data}) => {
            dispatch({
                type: POST_SAVE_ROUTE_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: POST_SAVE_ROUTE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getIsRoutesSet(batches, driverId){
    return function(dispatch){
        dispatch({type: GET_IS_ROUTES_SET})
        return adminServerInstance.get('/map/ispathexist', {
            params: {
                batch_list: batches.toString(),
                driver_id: driverId
            }
        }).then(({data}) => {
            dispatch({
                type: GET_IS_ROUTES_SET_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_IS_ROUTES_SET_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getRoutePlannedCount(branch, batches){
    return function(dispatch){
        dispatch({type: GET_ROUTE_PLANNED_COUNT})
        return adminServerInstance.get('/map/getdriverordercountmerged', {
            params: {
                branch,
                batch_list: batches.toString()
            }
        }).then(({data}) => {
            dispatch({
                type: GET_ROUTE_PLANNED_COUNT_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_ROUTE_PLANNED_COUNT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        })
    }
}

export function getDriverOrdersIds( driverId, batchIds=[], isHideAssociated=true, isHideSubRef=false, warehouseId){
    return adminServerInstance.get(`/map/getdriverordersinbatchlist`, {
        params: {
            driver_id: driverId,
            batch_list: batchIds.toString(),
            hide_associated: isHideAssociated ? 1:0,
            // hide_sub_referrer: isHideSubRef ? 1: 0
            hide_sub_referrer: 0,
            branch: warehouseId
        }
    }).then(({data}) => {
        let orders = _.map(data.data.orders, _.partialRight(_.pick, ['order_id', 'lat', 'lng']))
        return Promise.resolve(orders);
    }).catch(error => {
        return Promise.reject(error);
    })
}

export function generateAndSaveRouteByOrders(orders, start, end, driverName,driverID, batch_list, routeType, warehouse){
    return adminServerInstance.post('/map/generateandsaveroutebyorders', {
        orders,
        start, 
        end,
        driver_name: driverName,
        batch_list: batch_list,
        driver_id:driverID,
        plan_type: routeType,
        warehouse: warehouse
    }).then(({data}) => {
        return Promise.resolve(data.data);
    }).catch(error => {
        return Promise.reject(error);
    })
}